import React from 'react';
import Toggle from './Toggle';
import {
  ProviderFiltersType,
  UpdateFilterType,
} from 'components/types/FilterTypes';

type PreferredProviderFilterProps = {
  selectedFilters: ProviderFiltersType;
  setActiveFilterPanel: Function;
  updateFilter: UpdateFilterType;
};

const PreferredProviderFilter = (props: PreferredProviderFilterProps) => {
  const { updateFilter } = props;

  return (
    <div className="filter-preferred-provider">
      <span>OSF Preferred Providers Only</span>
      <Toggle onChange={updateFilter} />
    </div>
  );
};

export default PreferredProviderFilter;
